// extracted by mini-css-extract-plugin
export var copyright = "Footer-module--copyright--we5XP";
export var label = "Footer-module--label--owUz1";
export var link = "Footer-module--link--mmlUV";
export var logotype = "Footer-module--logotype--DEJ4j";
export var partnerWrapper = "Footer-module--partnerWrapper--52u5p";
export var wrapper = "Footer-module--wrapper--jJ9Zt";